var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHausIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3345,
    cy: 47.2056,
    r: 46.8326,
    fill: "#0E1235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1961 35.1958H35.2812V47.0459H47.1961V35.1958Z",
    fill: "#F2CF63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.257 33.9204H47.1719V22.7178H35.257V33.9204Z",
    fill: "#6D94CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9757 33.9204H33.8906V22.7178H21.9757V33.9204Z",
    fill: "#FE1D5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8223 33.8999C49.8223 27.3597 55.1645 22.0498 61.7372 22.0498V33.8999H49.8223Z",
    fill: "#1A84DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1046 47.0791L75.0195 47.0791L75.0195 35.229L63.1046 35.229L63.1046 47.0791Z",
    fill: "#6D94CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8223 47.0783L61.7372 35.1958H49.8223V47.0783Z",
    fill: "#FE1D5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0438 33.8999C75.0438 27.3597 69.7015 22.0498 63.1289 22.0498V33.8999H75.0438Z",
    fill: "#F2CF63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0449 60.2588C50.0449 53.7186 55.3872 48.4087 61.9598 48.4087V60.2588H50.0449Z",
    fill: "#1A84DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0449 61.5532L61.9598 73.4357V61.5532H50.0449Z",
    fill: "#6D94CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2411 73.4375C75.2411 66.8973 69.8988 61.5874 63.3262 61.5874V73.4375H75.2411Z",
    fill: "#FE1D5B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1961 61.5532C47.1961 68.0935 41.8539 73.4034 35.2812 73.4034V61.5532H47.1961Z",
    fill: "#F2CF63"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9746 61.5532C21.9746 68.0935 27.3169 73.4034 33.8895 73.4034V61.5532H21.9746Z",
    fill: "#1A84DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9321 60.2588C31.2223 60.2588 33.8895 57.6061 33.8895 54.3338C33.8895 51.0614 31.2223 48.4087 27.9321 48.4087C24.6418 48.4087 21.9746 51.0614 21.9746 54.3338C21.9746 57.6061 24.6418 60.2588 27.9321 60.2588Z",
    fill: "#6D94CE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2836 60.2588C72.5738 60.2588 75.2411 57.6061 75.2411 54.3338C75.2411 51.0614 72.5738 48.4087 69.2836 48.4087C65.9934 48.4087 63.3262 51.0614 63.3262 54.3338C63.3262 57.6061 65.9934 60.2588 69.2836 60.2588Z",
    fill: "#F2CF63"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8884 35.1958H30.8125V47.0459H33.8884V35.1958Z",
    fill: "#1A84DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4509 35.1958H26.375V47.0459H29.4509V35.1958Z",
    fill: "#1A84DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0505 35.1958H21.9746V47.0459H25.0505V35.1958Z",
    fill: "#1A84DD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3259 48.4087H44.25V60.2588H47.3259V48.4087Z",
    fill: "#FE1D5B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8942 48.4087H39.8184V60.2588H42.8942V48.4087Z",
    fill: "#FE1D5B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.488 48.4087H35.4121V60.2588H38.488V48.4087Z",
    fill: "#FE1D5B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHausIcon);
export default __webpack_public_path__ + "static/media/haus_icon.445212878bddeed5d9a2534193a06d9a.svg";
export { ForwardRef as ReactComponent };